// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"53fe26d2","605":"bff5fb87","725":"8fc0c735"}[chunkId] + ".chunk.js";
};